import { createClient } from '@supabase/supabase-js'

// Project credentials from Supabase
const SUPABASE_URL = 'https://jxduqribodsosynoxxpn.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp4ZHVxcmlib2Rzb3N5bm94eHBuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE5NjI0NTQsImV4cCI6MjA2NzUzODQ1NH0.yu2LZq7e9BXjIEoIOm3u4t0V_oarTN7TNt5kWU5ervc'

if(SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>'){
  throw new Error('Missing Supabase variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase